import { render, staticRenderFns } from "./statistics_num.vue?vue&type=template&id=67bb69f7"
import script from "./statistics_num.vue?vue&type=script&lang=js"
export * from "./statistics_num.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports